import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { useCleanupRedux } from '../../common/hooks'
import { apolloService } from '../../common/services'

import { CHALLENGES_QUERY } from '../graphql/queries'
import { FETCH_CHALLENGES } from '../redux/action-types'
import { cleanupFetchChallenges } from '../redux/actions'

const useChallengesQuery = () => {
  const dispatch = useDispatch()
  useCleanupRedux(cleanupFetchChallenges)

  const { isLoading, error, initialData, latestEvent } = useSelector(
    store => store.challenges.challenges,
  )

  const refetch = useCallback(
    () => apolloService.query(CHALLENGES_QUERY, {}, dispatch, FETCH_CHALLENGES),

    [dispatch],
  )

  useEffect(() => {
    refetch()
  }, [refetch])

  return { isLoading, error, initialData, latestEvent }
}

export default useChallengesQuery
